import { format } from 'date-fns';

export const parseApiLocalDate = (dateStr: string | null | undefined): Date | null => {
  // Use for parsing API Date to js date object
  if (!dateStr) return null;
  const [y, m, d] = dateStr.split('-').map(Number);
  const date = new Date(y, m - 1, d);
  return isNaN(date.getTime()) ? null : date;
};

export const parseFormDate = (dateStr: Date | null): string | null => {
  // Use to parse form date to an iso api date string
  if (!dateStr) return null;
  const year = dateStr.getFullYear();
  const month = String(dateStr.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
  const day = String(dateStr.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

interface FormatApiDateOptions {
  dateFormat?: string;
  prefix?: string;
  emptyLabel?: string;
}

export const formatApiDate = (
  // Use to format API Date fields and avoid timezone shift issues, will display the date exactly as returned in API
  // Optional prefix label E.g. 'Starts on' and Optional empty label E.g. '-' or 'No Start Date'
  dateStr: string | null | undefined,
  { dateFormat = 'MMM d, yyyy', prefix, emptyLabel = '-' }: FormatApiDateOptions = {}
): string => {
  const date = parseApiLocalDate(dateStr);
  if (!date) return emptyLabel;
  const formatted = format(date, dateFormat);
  return prefix ? `${prefix} ${formatted}` : formatted;
};

export const formatDateTo24Hr = (
  // Formats a date string or Date object to 24-hour time format
  // Accepts an optional format string, defaults to 'MM/dd/yyyy HH:mm'
  dateInput: string | Date | null | undefined,
  dateFormat: string = 'MM/dd/yyyy HH:mm'
): string => {
  if (!dateInput) return '';
  const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
  if (isNaN(date.getTime())) return '';
  return format(date, dateFormat);
};
